import { DEFAULT_LOCALE, LOCALES } from "./locales.constants";
import { TLocale } from "./locales.models";

export const isLocale = (value: string | undefined): value is TLocale =>
  LOCALES.includes(value as TLocale);

/**
 * Narrows whatever i18next reports as the active language to a locale we ship.
 * i18next may hand back a region tag (`en-GB`) or an unknown language.
 */
export const toLocale = (value: string | undefined): TLocale => {
  const base = value?.split("-")[0];

  if (!isLocale(base)) return DEFAULT_LOCALE;

  return base;
};
